<template>
  <div class="input-container" :data-name="inputId">
    <input type="checkbox" :id="inputId" v-if="type === 'checkbox'" :value="value" @input="processInput" /><!--
    --><label :for="inputId">{{ label }}{{ required ? '*' : '' }}</label>
    <input type="text" :id="inputId" v-if="type === 'text'" :value="value" @input="processInput" />
    <input type="tel" :id="inputId" v-else-if="type === 'tel'" :value="value" @input="processInput" v-mask="'+7 (###) ###-##-##'" />
    <input type="number" :id="inputId" v-else-if="type === 'number'" :value="value" @input="processInput" min="0" />
    <textarea :id="inputId" v-else-if="type === 'textarea'" :value="value" @input="processInput"></textarea>
    <select-input v-else-if="type === 'select'" :inputId="inputId" :value="value" @input="processInput" :options="selectOptions" />
  </div>
</template>

<script>
  import SelectInput from '/src/components/SelectInput'

  export default {
    name: 'InputContainer',
    components: {
      SelectInput
    },
    watch: {
      value (newVal) {
        if (this.inputId === 'phone' && newVal.length < 4) {
          this.$emit('input', '+7 (')
        }
      }
    },
    props: {
      label: {
        type: String,
        required: true
      },
      inputId: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'text'
      },
      value: {
      },
      required: {
        type: Boolean,
        default: false
      },
      selectOptions: {
        type: Array
      }
    },
    methods: {
      processInput (ev) {
        if (this.type === 'select') {
          this.$emit('input', ev)
        } else if (this.type === 'checkbox') {
          this.$emit('input', ev.target.checked)
        } else {
          this.$emit('input', ev.target.value)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/InputContainer.vue